import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AssetTypename } from './AssetTypename';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type HydrateSelectedAssetTypesQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  ids: Array<Types.Scalars['ID']['input']>;
  first: Types.Scalars['NonNegativeInt']['input'];
}>;


export type HydrateSelectedAssetTypesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, assets?: { __typename?: 'AssetConnection', nodes: Array<{ __typename: 'AudioAsset', id: string } | { __typename: 'DocumentAsset', id: string } | { __typename: 'FileAsset', id: string } | { __typename: 'FolderAsset', id: string } | { __typename: 'ImageAsset', id: string } | { __typename: 'InteractiveAsset', id: string } | { __typename: 'InteractiveLiveAsset', id: string } | { __typename: 'ModelAsset', id: string } | { __typename: 'UnsupportedAsset', id: string } | { __typename: 'VersionStackAsset', id: string } | { __typename: 'VideoAsset', id: string }> } | null } | null };


export const HydrateSelectedAssetTypes = /*#__PURE__*/ gql`
    query HydrateSelectedAssetTypes($accountId: ID!, $ids: [ID!]!, $first: NonNegativeInt!) {
  account(by: {id: $accountId}) {
    id
    assets(assetIds: $ids, page: {first: $first}) {
      nodes {
        ...AssetTypename
      }
    }
  }
}
    ${AssetTypename}` as unknown as DocumentNode<HydrateSelectedAssetTypesQuery, HydrateSelectedAssetTypesQueryVariables>;

          

          export const useHydrateSelectedAssetTypesQuery = (options?:QueryHookOptions<HydrateSelectedAssetTypesQuery, HydrateSelectedAssetTypesQueryVariables>) => useQuery(HydrateSelectedAssetTypes, options);

          

          export type HydrateSelectedAssetTypesQueryOptions = QueryHookOptions<HydrateSelectedAssetTypesQuery, HydrateSelectedAssetTypesQueryVariables>;

          

          export const useHydrateSelectedAssetTypesLazyQuery = (options?:LazyQueryHookOptions<HydrateSelectedAssetTypesQuery, HydrateSelectedAssetTypesQueryVariables>) => useLazyQuery(HydrateSelectedAssetTypes, options);

          

          export type HydrateSelectedAssetTypesQueryResult = ReturnType<typeof useHydrateSelectedAssetTypesQuery>;

          
